// 토모플레이 - 본사 - 지사별 사용량 메인 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";
import AgGridReactEx from "@app/components/AgGridReactEx";

import playStyle from "../../components/style";

import CardStatContent, { CardStatBranchContent } from "../../components/CardStatContent";
import BranchContentList from "./BranchContentList";

const BranchContent = forwardRef(({ branchList, statPeriod, selectedSubOption = "content", updateViewSubOption, onViewSubOptionSelected }, ref) => {
    const [subOptionApplied, setSubOptionApplied] = useState(false);
    const [stat, setStat] = useState(false);
    const [statJoinData, setJoinData] = useState(false);
    const [statData, setData] = useState(false);
    const [totalCount, setTotalCount] = useState(false);
    const [categoryList, setCategoryList] = useState(false);
    const [sortOption, setSortOption] = useState({ colId: "nurseryName", sort: "asc" });
    const typeTitle = selectedSubOption === "content" ? "순" : selectedSubOption == "join" ? "가입 비율" : "누적";

    let listColumn = [
        {
            headerName: "No",
            field: "id",
            minWidth: 45,
            width: 80,
            sortable: false,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "지사명",
            field: "branchName",
            width: 200,
            minWidth: 100,
            cellClass: "text-left",
        },
        {
            headerName: "계약원아 수",
            field: "contractCount",
            minWidth: 100,
            width: 100,
            sort: "desc",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "초대원아 수",
            field: "inviteCount",
            minWidth: 100,
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "초대원아 비율",
            field: "inviteRatio",
            minWidth: 100,
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "가입원아 수",
            field: "parentCount",
            minWidth: 100,
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "가입원아 비율",
            field: "parentRatio",
            minWidth: 100,
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: `토모플레이 (${typeTitle})통계`,
                sheets: [
                    {
                        name: "콘텐츠",
                        title: `토모플레이 지사 (${typeTitle}) 통계`,
                        columnTitle: [].concat(
                            typeTitle != "가입 비율"
                                ? ["지사명", "전체"].concat(categoryList.map((lc) => `${lc.name} ${typeTitle}`))
                                : [listColumn[1].headerName, listColumn[2].headerName, listColumn[3].headerName, listColumn[4].headerName, listColumn[5].headerName, listColumn[6].headerName]
                        ),
                        data: [].concat(
                            typeTitle != "가입 비율"
                                ? statData.map((s) => [s.branchName, s.total].concat(categoryList.map((m) => s[m.id])))
                                : statJoinData.map((s) => [s.branchName, s[listColumn[2].field], s[listColumn[3].field], s[listColumn[4].field], s[listColumn[5].field], s[listColumn[6].field]])
                        ),
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        setStat(false);
        if (subOptionApplied == true) {
            axios({
                method: "POST",
                url: `/api/play_stat/play/branch/content`,
                data: {
                    startDate: statPeriod.startDate,
                    endDate: statPeriod.endDate,
                    periodType: statPeriod.type,
                    type: selectedSubOption,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        var stat = result.data.data;
                        var tableData = [];
                        let totalCount = 0;
                        if (stat.branchCount.length > 0) {
                            stat.branchCount.reduce((acc, branch, idx) => {
                                if (idx == 1) acc = { branchName: acc.branchName, [acc.menu]: acc.playCount, total: acc.playCount };
                                if (acc.branchName != branch.branchName || idx == stat.branchCount.length - 1) {
                                    if (acc) tableData.push(acc);
                                    totalCount += acc.total;
                                    acc = branch;
                                    acc[branch.menu] = branch.playCount;
                                    acc.total = branch.playCount;
                                    delete acc.menu;
                                    delete acc.playCount;
                                    return acc;
                                } else {
                                    acc[branch.menu] = branch.playCount;
                                    acc.total += branch.playCount;
                                    return acc;
                                }
                            });
                        }

                        tableData.sort((a, b) => {
                            if (a.total < b.total) return 1;
                            if (a.total > b.total) return -1;

                            return 0;
                        });
                        stat.branchJoin.map((s) => {
                            s.inviteRatio = ((s.inviteCount / s.contractCount) * 100).toFixed(1) + "%";
                            s.parentRatio = ((s.parentCount / s.contractCount) * 100).toFixed(1) + "%";
                        });

                        setStat(stat);
                        setData(tableData);
                        setCategoryList(stat.categoryList);
                        setJoinData(stat.branchJoin);
                        setTotalCount(totalCount);
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    }, [statPeriod, selectedSubOption]);
    useEffect(() => {
        if (!subOptionApplied && updateViewSubOption) {
            updateViewSubOption(
                [
                    { name: "콘텐츠 순 실행 수", id: "content" },
                    { name: "콘텐츠 누적 실행 수", id: "sum" },
                    { name: "가입 비율", id: "join" },
                ],
                "content"
            );
            setSubOptionApplied(true);
        }
        getStat();
        return () => {};
    }, [getStat, subOptionApplied]);
    const series = playStyle.seriesPlayChart.map((s) => Object.assign({}, s));
    const chartOption = {
        xAxis: {
            field: "branchName",
            option: {
                axisLabel: {
                    show: true,
                    interval: 0,
                    rotate: 45,
                },
            },
        },
        yAxis: {
            name: "건",
            series: series,
        },
        stacks: [{ stack: "base", title: `토모플레이 ${selectedSubOption === "content" ? "순" : "누적"} 실행 수`, showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "10%",
            left: "5%",
            right: "5%",
            bottom: "15%",
        },
    };

    function onListSortChanged(colId, sort) {
        setSortOption({ sortOption: { colId, sort } });
    }

    const branchTop = statData && statData.length > 0 ? statData[0] : null;
    const branchLast = statData && statData.length > 0 ? statData[statData.length - 1] : null;
    return (
        <div className="stat-branch-content">
            {selectedSubOption != "join" ? (
                <div>
                    <div className="row mb-2">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatContent
                                id="1"
                                title={`전체 콘텐츠 ${typeTitle} 실행 수`}
                                average={isNaN((totalCount / statData.length).toFixed(1)) ? "0" : (totalCount / statData.length).toFixed(1)}
                                titleTotal="합계:"
                                total={totalCount ? totalCount : 0}
                                titleBgClass="bg-tomonote"
                            />
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <CardStatBranchContent id="4" top={branchTop} last={branchLast} />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <div className="card">
                                <div className="card-body" style={{ height: "500px", textAlign: "center" }}>
                                    <CommonHorizontalBarChart chartData={statData} chartOption={chartOption} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <BranchContentList data={statData} categoryList={categoryList} onListSortChanged={onListSortChanged.bind(this)} />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="row">
                    <div className="col">
                        <AgGridReactEx
                            columnDefs={listColumn}
                            headerHeight={40}
                            rowData={statJoinData}
                            onRowClicked={(e) => {
                                onRowSelected(e);
                            }}
                            pagination={true}
                            overlayNoRowsTemplate={`<span>통계 자료가 없습니다.</span>`}
                        />{" "}
                    </div>
                </div>
            )}
        </div>
    );
});

export default BranchContent;
